import { PlatformFeature } from 'api'
import React from 'react'
import { useSelector } from 'react-redux'

import { createPlatformFeatureEnabledSelector } from 'selectors/platformSelectors'

export const FeatureToggle: React.FC<{ feature: PlatformFeature; children: React.ReactElement }> = ({ feature, children }) => {
  const isEnabled = useSelector(createPlatformFeatureEnabledSelector(feature))
  return isEnabled ? children : null
}
